import {
  init,
  setUserId,
  track,
  getUserId,
} from '@amplitude/analytics-browser';
import { ENV, getDeviceOS } from '@autopass-web/domain';
import AbstractAnalyticsLogger from './abstract-analytics-logger';

export class AmplitudeAnalyticsLogger implements AbstractAnalyticsLogger {
  key: string;
  constructor() {
    this.key = '';
  }

  init(key: string, userId?: string) {
    init(key, userId);
    this.key = key;
  }

  getKey() {
    return this.key;
  }

  getUserId() {
    return getUserId();
  }

  setUserId(id: string) {
    setUserId(id);
  }

  log = (name: string, properties: any = {}) => {
    properties['deviceType'] = getDeviceOS();
    if (ENV !== 'production') {
      console.table(name, properties);
    }
    track(name, properties);
  };
}
